import { ReactElement } from 'react'

import { personalInformationSchema, addressSchema, insuranceSchema, lifestyleSchema } from '@ana/shared'
import { canSkipAnamnesis, canSkipFactoring } from 'helpers/steps'
import * as Yup from 'yup'

import Patient from '../@types/Patient'
import { ReactComponent as AnamnesisIcon } from '../assets/icons/anamnesis-icon.svg'
import { ReactComponent as FinishIcon } from '../assets/icons/finish-icon.svg'
import { ReactComponent as GeneralInformationIcon } from '../assets/icons/general-information-icon.svg'
import { ReactComponent as WishesIcon } from '../assets/icons/wishes-icon.svg'
import mergeSchemas from '../helpers/mergeValidationSchemas'

import { routes } from './routes'

export type MenuItem = {
  path: string
  label: string
  icon: ReactElement
  steps: string[]
  getSteps?: (patient: Patient | undefined) => string[]
  validation?: Yup.ObjectSchema
}

const ADDITIONAL_DETAIL_MANDATORY_STEPS = [
  routes.preparations.path,
  routes.wishes.path,
  routes.wishes2.path,
  routes.wishes3.path,
  routes.referral.path,
]

const menuItems: MenuItem[] = [
  {
    path: routes.personalInformation.path,
    label: 'category.general_information',
    icon: <GeneralInformationIcon />,
    steps: [routes.personalInformation.path, routes.address.path, routes.insurance.path],
    validation: mergeSchemas(personalInformationSchema, addressSchema, insuranceSchema, lifestyleSchema),
  },
  {
    path: routes.preConditions1.path,
    label: 'category.anamnesis',
    icon: <AnamnesisIcon />,
    steps: [routes.preConditions1.path, routes.preConditions2.path, routes.preConditions3.path, routes.allergies.path],
  },
  {
    path: routes.wishes.path,
    label: 'category.whishes_expectations',
    icon: <WishesIcon />,
    steps: [...ADDITIONAL_DETAIL_MANDATORY_STEPS],
  },
  {
    path: routes.summary.path,
    label: 'category.finalize',
    icon: <FinishIcon />,
    steps: [routes.consents.path, routes.summary.path, routes.factoringAgreement.path, routes.success.path],
    getSteps: (patient) => {
      const stepsCompleted = patient?.anamnesisState || []

      const result = [
        !canSkipAnamnesis(stepsCompleted) && routes.consents.path,
        !canSkipAnamnesis(stepsCompleted) && routes.summary.path,
        !canSkipFactoring(stepsCompleted) && routes.factoringAgreement.path,
        routes.success.path,
      ].filter((entry) => typeof entry === 'string') as string[]

      return result
    },
  },
]

export default menuItems
